import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {TranslatePipe} from '../translate.pipe';
import {TranslateService} from '../shared/services/translate.service';
import {Router} from '@angular/router';
import {Registration} from '../shared/classes/Registration';
import {RegistrationService} from '../shared/services/registrationService/registration.service';

@Component({
  selector: 'app-single',
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.css']
})
export class SingleComponent implements OnInit {

  sex = [];

  public singleForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    surname: ['', [Validators.required]],
    year: ['', [Validators.required, Validators.min(1900)]],
    sex: ['', [Validators.required]],
    category: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    mobile: ['+420', [Validators.required,  Validators.minLength(6), Validators.pattern('^\\+[0-9]+$'), ]],
    club: ['', []],
    voucher: ['', []],
    note: ['', []],
    gdpr: ['', [Validators.required, Validators.requiredTrue]]
  });

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private registrationService: RegistrationService) {
    this.sex.push('formPage.single.man');
    this.sex.push('formPage.single.woman');

    if (this.registrationService.goBack) {
      const reg = this.registrationService.registration;
      this.singleForm.setValue({
      name: reg.name,
      surname: reg.surname,
      year: reg.year,
      sex:  reg.sex,
      category:  reg.category,
      email:  reg.email,
      mobile: reg.mobile,
      club:  reg.club,
      voucher:  reg.voucher,
      note:  reg.note,
      gdpr: false
      });
    }
  }

  ngOnInit() {
  }

  login() {
    const registration: Registration = {
      name: this.singleForm.value.name,
      surname: this.singleForm.value.surname,
      year: this.singleForm.value.year,
      sex: this.singleForm.value.sex,
      category: this.singleForm.value.category,
      email: this.singleForm.value.email,
      mobile: this.singleForm.value.mobile,
      club: this.singleForm.value.club,
      voucher: this.singleForm.value.voucher,
      note: this.singleForm.value.note
    };
    this.registrationService.registration = registration;
    this.router.navigate(['/recapitulation']);
  }

}
